import { render, staticRenderFns } from "./MatchMma.vue?vue&type=template&id=f6151dec&scoped=true&"
import script from "./MatchMma.vue?vue&type=script&lang=js&"
export * from "./MatchMma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6151dec",
  null
  
)

export default component.exports